import { lazy, Suspense, useEffect, useState } from "react";
const Router = lazy(() => import("./config/router"));
const Navbar = lazy(() => import("./components/Navbar/Navbar"));
import { BrowserRouter } from "react-router-dom";
import { Flip, ToastContainer } from "react-toastify";
import Cookies from "js-cookie";
import { useAuthStore } from "./features/Auth";
import LoadingPage from "./features/CNP/pages/LoadingPage";
import { useScreenSize } from "./hooks/useScreenSize";
import { observer } from "mobx-react-lite";
import { setupAuthInterceptor } from "./utils/AuthInterceptor";
import { useOnboardStore } from "./features/OnBoard/hooks/useOnboardStore";
import { useCompanyStore } from "./features/Company";
import "./styles/globals.css";

const App = observer(() => {
  useScreenSize();
  const { getMe, setIsLoading, isUserLogin } = useAuthStore();
  const { getCompany } = useOnboardStore();
  const { selectedCompanyId } = useCompanyStore();

  const theme = Cookies.get("theme");
  const token = Cookies.get("token");

  setupAuthInterceptor();
  useEffect(() => {
    if (token) {
      getMe().then((success) => {
        if (success) setIsLoading(false);
      });
    } else {
      setIsLoading(false);
    }
  }, [getMe, token]);

  useEffect(() => {
    if (token) {
      if (selectedCompanyId) {
        getCompany();
      }
    }
  }, [selectedCompanyId]);

  useEffect(() => {
    if (!theme) {
      Cookies.set("theme", "light", { sameSite: "Strict" });
    }

    if (theme) {
      document.body.classList.add(theme);
    } else if (window.matchMedia("(prefers-color-scheme: light)").matches) {
      document.body.classList.add("light");
    } else {
      document.body.classList.add("light");
    }
  }, [theme]);

  return (
    <>
      <BrowserRouter>
        <div className="flex flex-col h-screen">
          <Suspense fallback={<LoadingPage />}>
            {isUserLogin && <Navbar />}
            <Router />
          </Suspense>
        </div>
      </BrowserRouter>
      <ToastContainer
        className="whitespace-pre-line text-sm"
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Flip}
      />
    </>
  );
});

export default App;
